/* Bookeaz: keep Add to Cart enabled after a variant switch (gift card $10/$25/$50/$100 showed "Sold out").
   Cause: Webkul's buy-buttons markup hard-codes disabled on the add button. Dawn re-reads that server HTML after every
   variant change and shows "Sold out". The Bug-2 script re-enables only at page load.
   Fix: remember if the button was enabled before the shopper changed an option; after Dawn's variantChange event,
   restore it only if it was enabled before AND the new variant is available. A real out-of-range block (button never
   enabled) or a truly sold-out variant is never overridden. */
(function () {
  'use strict';
  if (window.__bkzVariantAtcFix) return;
  window.__bkzVariantAtcFix = true;
  var wasEnabled = false;

  function addBtn() {
    return document.querySelector('product-info product-form button[name="add"]');
  }
  function record() {
    var b = addBtn();
    if (b && !b.disabled) wasEnabled = true;
  }
  function inVariantSelects(e) {
    return e.target && e.target.closest && e.target.closest('variant-selects');
  }
  ['pointerdown', 'change'].forEach(function (type) {
    document.addEventListener(type, function (e) { if (inVariantSelects(e)) record(); }, true);
  });

  function init() {
    record();
    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined' || !PUB_SUB_EVENTS.variantChange) return;
    subscribe(PUB_SUB_EVENTS.variantChange, function (ev) {
      var d = ev && ev.data;
      if (!wasEnabled) return;
      if (d && d.variant && d.variant.available === false) return;
      var form = document.querySelector('product-info product-form');
      if (form && typeof form.toggleSubmitButton === 'function') form.toggleSubmitButton(false);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();